import React, { Component } from 'react';
import Container from 'react-bootstrap/Container';
import _ from 'lodash';
import Alert from 'react-bootstrap/Alert';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Spinner from 'react-bootstrap/Spinner';
// import '../resource/css/centerlogin.css';
import qs from 'query-string';
import ReactApexChart from 'react-apexcharts';
import config from '../../config';

class DeathChartRecoveryV2 extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
            loading:true,
            series: [],
            options: {
                chart: {
                    height: '100%',
                    type: 'area',
                    stacked: false
                },
                
                dataLabels: {
                    enabled: false
                },
                markers: {
                    size: 2.5,
                },
                fill: {
                    type: 'gradient',
                    gradient: {
                        shadeIntensity: 1,
                        inverseColors: false,
                        opacityFrom: 0.15,
                        opacityTo: 0.05,
                        stops: [20, 100, 100, 100]
                      },
                },
                // colors: ['#055a87', '#7da19d' ],
                stroke: {
                    show: true,
                    curve: 'smooth',
                    lineCap: 'butt',
                    // colors: ['#5c5c5c'],
                    width: 2,
                    dashArray: 0,      
                },
               
                xaxis: {
                    type: 'datetime',
                    categories: [],
                    labels: {
                        datetimeFormatter: {
                            year: 'yyyy',
                            month: 'MMM dd',
                            day: 'MMM dd',
                        }
                    }
                },
                
                legend: {
                    horizontalAlign: 'left',
                    offsetX: 0
                }
            },
      
      
      };
    }

    async loadOut(){
        const qValues = qs.parse(this.props.location.search);
        let formData;
        let qResp;
        let qData;
        let twoWeekData=[];
        let cleanDate=[];
        let cleanCasestotal=[];
        let cleanCasesPerDay=[];
        let cleanCasesMovingDay=[];
        let trendData=[];
        let qWhere="casesTotal IS NOT NULL";
        let fieldMap;
        let url;
        let offSwitch=false;
        let qMap={
            Day3:{
                cases:{
                    field:"Death3DayMovingAvg",
                    text:"3 Day Avg"
                }
            },
            Day7:{
                cases:{
                    field:"Death7DayMovingAvg",
                    text:"7 Day Avg"
                }
            },
            Day14:{
                cases:{
                    field:"Death14DayMovingAvg",
                    text:"14 Day Avg"
                }
            }
        };


        if (qValues.type == null){
            url=config.apiv2.covidCases;
            qWhere="deathNewByDay IS NOT NULL";
        }else if(qValues.type==="all"){
            url=config.apiv2.covidCases;
            qWhere="deathNewByDay IS NOT NULL";
        }else if(qValues.type==="all14"){
            url=config.apiv2.covidRecoveryAllTwoWeeks;
            qWhere="deathNewByDay IS NOT NULL";
        }else if(qValues.type==="14"){
            url=config.apiv2.covidRecoveryAllTwoWeeks;
            qWhere="deathNewByDay IS NOT NULL AND current14DRecord=1";
        }else{
            url=config.apiv2.covidCases;
            qWhere="deathNewByDay IS NOT NULL";
        }
            
        if (qValues.trend == null){
            fieldMap=qMap.Day3;
        } else if(qValues.range==="3"){
            fieldMap=qMap.Day3; 
        } else if(qValues.trend==="7"){
            fieldMap=qMap.Day7;
        }else if(qValues.trend==="14"){
            fieldMap=qMap.Day14;
        }else if(qValues.trend==="off"){
            fieldMap=qMap.Day14;
            offSwitch=true;
        }else{
            fieldMap=qMap.Day3;
        }

        formData=new FormData()
        formData.append("where",qWhere);
        formData.append("outFields",['date','deathNewByDay','Death3DayMovingAvg','Death7DayMovingAvg','Death14DayMovingAvg','current14DRecord']);
        formData.append("returnGeometry","false");
        formData.append("orderByFields","date");
        formData.append("returnDistinctValues","false");
        formData.append("f","json");

        try{
            qResp = await fetch(url+"/query",{method:"post",body:formData});
            qData = await qResp.json();
        }catch(err){
            console.log(err);
        }

        if(_.get(qData,"features.length",0)>0){
            // console.log(qData.features);
            let startTwoWeek=qData.features[qData.features.length-14];
            let endTwoWeek=qData.features[qData.features.length-1];
            let mostRecentDate=(new Date(endTwoWeek.attributes.date)).getTime();
            let twoWeekDate=(new Date(startTwoWeek.attributes.date)).getTime();
            let trendText="";
            let trendColor="";
            let trendData=[];
            let oldChangeValue;
            let ct=0;
            let change = endTwoWeek.attributes.deathNewByDay-startTwoWeek.attributes.deathNewByDay;
            let change14 = change/14;

            if(change14<=0){
                //decline - green
                trendColor='#00ff00';
                trendText='2 Week Decrease ('+change14.toFixed(2)+')';
            }else{
                //increase - red
                trendColor='#FF0000';
                trendText='2 Week Increase ('+change14.toFixed(2)+')';
            }
            _.forEach(qData.features,function(value,key){

                if(value.attributes.date===twoWeekDate){
                    trendData.push(value.attributes.deathNewByDay);
                    oldChangeValue=value.attributes.deathNewByDay;
                }else if(value.attributes.date===mostRecentDate){
                    trendData.push(value.attributes.deathNewByDay);
                    oldChangeValue=value.attributes.deathNewByDay;
                }else if(value.attributes.date>=twoWeekDate && value.attributes.date<=mostRecentDate){
                    trendData.push((oldChangeValue+change14).toFixed(2));
                    oldChangeValue=oldChangeValue+change14;
                }else{
                    trendData.push(null);
                }

                
                var validDate = (new Date(value.attributes.date)).getTime();
                let casesNewByDay=value.attributes.deathNewByDay;
                let casesMovingDay=value.attributes[fieldMap.cases.field];
                
                if(casesNewByDay==null){
                    casesNewByDay=0;
                }
                if(casesMovingDay==null){
                    casesMovingDay=0;
                }
                cleanDate.push(validDate);
                cleanCasesPerDay.push(casesNewByDay);
                cleanCasesMovingDay.push(casesMovingDay.toFixed(2));
            });

            if(offSwitch===true){
                // no trend
                this.setState({
                    series: [
                        {
                            name: 'New Deaths Per Day',
                            type: 'area',
                            data: cleanCasesPerDay
                        },
                        {
                            name: 'Two Week Trend',
                            type:'area',
                            data:trendData
                        }
                        
                    ],
                    options: {
                      ...this.state.options,
                      colors: ['#00a9e6', trendColor],
                      yaxis: [
                        {
                            seriesName: 'Deaths Per Day',
                            show: true,
                            opposite: false,
                            axisTicks: {
                                show: true,
                            },
                            axisBorder: {
                                show: true,
                            },
                            
                            title: {
                                text: "Deaths Per Day",
                            }
                        },
                
                        
                    ],
                      annotations: {
                        xaxis: [{
                          x:twoWeekDate,
                          x2:mostRecentDate,
                          borderColor: trendColor,
                          label: {
                            borderColor: trendColor,
                            style: {
                              color: '#fff',
                              background: trendColor,
                            },
                            text: trendText,
                          }
                        }],
                      },
                      xaxis: {
                        ...this.state.options.xaxis,
                        categories:cleanDate
                      }
                    },
                    loading:false,
                    error:false
                });
            }else{
                // trend
                this.setState({
                    series: [
                        {
                            name: 'New Deaths Per Day',
                            type: 'area',
                            data: cleanCasesPerDay
                        },
                        
                        {
                            name:fieldMap.cases.text,
                            type:"area",
                            data:cleanCasesMovingDay
                        },
                        {
                            name: 'Two Week Trend',
                            type:'area',
                            data:trendData
                        }
                        
                    ],
                    options: {
                      ...this.state.options,
                      colors: ['#00a9e6','#bee8ff', trendColor],
                      yaxis: [
                        {
                            seriesName: 'Deaths Per Day',
                            show: true,
                            opposite: false,
                            axisTicks: {
                                show: true,
                            },
                            axisBorder: {
                                show: true,
                            },
                            title: {
                                text: "Deaths Per Day",
                            }
                        },
                
                        
                    ],
                      annotations: {
                        xaxis: [{
                          x:twoWeekDate,
                          x2:mostRecentDate,
                          borderColor: trendColor,
                          label: {
                            borderColor: trendColor,
                            style: {
                              color: '#fff',
                              background: trendColor,
                            },
                            text: trendText,
                          }
                        }],
                      },
                      xaxis: {
                        ...this.state.options.xaxis,
                        categories:cleanDate
                      }
                    },
                    loading:false,
                    error:false
                });
            }
            
            

        }else{
            // error handle
            this.setState({
                loading:false,
                error:true
            });
        }
    }

    componentDidMount(){
        this.loadOut();
    }

  

    render() {

        if(this.state.loading===true){
            return (
                <Container fluid style={{paddingRight:"0",paddingLeft:"0"}}>
                    <div id="loader" style={{textAlign:"center"}}>
                        <Row>
                            <Col>
                                <Spinner animation="border" variant="primary" />
                            </Col>
                        </Row>
                    </div>
                </Container>
            );

        }else if(this.state.loading===false && this.state.error===true){
            //show error
            return (
                <Container fluid style={{paddingRight:"0",paddingLeft:"0"}}>
                    <Alert></Alert>
                </Container>
            );
        }else{
            return (
                <Container fluid style={{paddingRight:"0",paddingLeft:"0"}}>
                    <div id="chart" style={{height:"92vh",paddingRight:"0",paddingLeft:"0"}}>
                        <ReactApexChart options={this.state.options} series={this.state.series} type="area" height={'100%'} />
                    </div>
                </Container>
            );

        }
    }
  }

export default DeathChartRecoveryV2;